import authApiService from "./userApiService";

const handleError = (error) => ({
  success: false,
  error:
    error.response?.data?.message ||
    error.response?.data?.error ||
    error.message ||
    "An unexpected error occurred",
  statusCode: error.response?.status,
});

const handleSuccess = (response) => ({
  success: true,
  data: response.data,
  statusCode: response.status,
});

export const toastAnalyticsService = {
  async getRestaurants() {
    try {
      const response = await authApiService.get("/toast-analytics/restaurants");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getSalesAnalytics({ startDate, endDate, restaurantIds, groupBy, aggregateBy } = {}) {
    try {
      const response = await authApiService.get("/toast-analytics/sales", {
        params: {
          startDate,
          endDate,
          restaurantIds: restaurantIds?.length ? restaurantIds.join(",") : undefined,
          groupBy: groupBy?.length ? groupBy.join(",") : undefined,
          aggregateBy,
        },
      });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },
};
